module.exports = __webpack_public_path__ + "media/images/japan/location_arrow_3-66bdd4b81f6e8b134a0104061586b5a0.svg";